import React from 'react';
import type { AiEvaluation } from '../types/meeting';

interface AiEvaluationProps {
  evaluation: AiEvaluation;
  isExpanded: boolean;
  onToggle: () => void;
}

const getBarClass = (value: number): string => {
  if (value >= 70) return 'high';
  if (value >= 40) return 'medium';
  return 'low';
};

const AiEvaluationComponent: React.FC<AiEvaluationProps> = ({
  evaluation,
  isExpanded,
  onToggle,
}) => {
  return (
    <div className="panel-section" id="ai-evaluation-section">
      <div className="section-title accordion-header" onClick={onToggle}>
        <div className="section-title-left">
          <span className="section-icon material-symbols-outlined">automation</span>
          AI評価
        </div>
        <span className="accordion-icon material-symbols-outlined">
          {isExpanded ? 'unfold_more' : 'unfold_less'}
        </span>
      </div>
      <div
        className={`meeting-emotion-container accordion-content ${isExpanded ? '' : 'collapsed'}`}
        id="ai-evaluation-content"
      >
        {/* ポジティブ */}
        <div className="emotion-item" data-metric="positive">
          <div className="emotion-label">
            <div className="emotion-label-left">
              <span>ポジティブ</span>
              <span
                className="emotion-info-icon"
                data-tooltip="会議の雰囲気が前向きかどうかを示します。議論が建設的で、ポジティブな方向に進んでいるかをAIが評価します。"
              >
                <span className="material-symbols-outlined">info</span>
              </span>
            </div>
            <span className="emotion-value" id="positive-value">
              {evaluation.positive}%
            </span>
          </div>
          <div className="emotion-bar-bg">
            <div
              className={`emotion-bar ${getBarClass(evaluation.positive)}`}
              id="positive-bar"
              style={{ width: `${evaluation.positive}%`, transition: 'width 0.5s ease' }}
            />
          </div>
        </div>

        {/* 理解度 */}
        <div className="emotion-item" data-metric="understanding">
          <div className="emotion-label">
            <div className="emotion-label-left">
              <span>理解度</span>
              <span
                className="emotion-info-icon"
                data-tooltip="参加者が議題を理解しているかを示します。適切な質問や確認が行われ、共通認識が形成されているかをAIが評価します。"
              >
                <span className="material-symbols-outlined">info</span>
              </span>
            </div>
            <span className="emotion-value" id="understanding-value">
              {evaluation.understanding}%
            </span>
          </div>
          <div className="emotion-bar-bg">
            <div
              className={`emotion-bar ${getBarClass(evaluation.understanding)}`}
              id="understanding-bar"
              style={{ width: `${evaluation.understanding}%`, transition: 'width 0.5s ease' }}
            />
          </div>
        </div>

        {/* 発言量 */}
        <div className="emotion-item" data-metric="activity">
          <div className="emotion-label">
            <div className="emotion-label-left">
              <span>発言量</span>
              <span
                className="emotion-info-icon"
                data-tooltip="参加者の発言の活発さを示します。全員が適切に発言し、一部の人だけが話している状態ではないかをAIが評価します。"
              >
                <span className="material-symbols-outlined">info</span>
              </span>
            </div>
            <span className="emotion-value" id="activity-value">
              {evaluation.activity}%
            </span>
          </div>
          <div className="emotion-bar-bg">
            <div
              className={`emotion-bar ${getBarClass(evaluation.activity)}`}
              id="activity-bar"
              style={{ width: `${evaluation.activity}%`, transition: 'width 0.5s ease' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiEvaluationComponent;
